import { Technology } from '../../backend/models/technology';
import { getClients, getPersons, getRings, getSections, getTags, getTechnologies } from '../Util/server';
import { msalInstance } from '..';
import { BaseLoaderResult, baseUnauthorizedResponse } from './BaseLoader';

export type AggregatedDataLoaderResult = BaseLoaderResult & { technologies: Technology[] };

const AggregatedDataLoader = async (): Promise<AggregatedDataLoaderResult> => {
  const loggedIn = Boolean(msalInstance.getActiveAccount());
  if (!loggedIn) {
    return { technologies: [], ...baseUnauthorizedResponse } as AggregatedDataLoaderResult;
  }
  const [technologies, rings, sections, tags, clients, persons] = await Promise.all([
    getTechnologies(),
    getRings(),
    getSections(),
    getTags(),
    getClients(),
    getPersons(),
  ]);
  return { technologies, rings, sections, tags, clients, persons };
};

export default AggregatedDataLoader;
